import { functions } from '.';

export async function add(args) {
  const adminClassesCreate = functions.httpsCallable('adminClassesCreate');
  const cls = await adminClassesCreate(args);
  return cls.data;
}

export async function update(args) {
  const adminClassesUpdate = functions.httpsCallable('adminClassesUpdate');
  const cls = await adminClassesUpdate(args);
  return cls.data;
}

export async function deleteClass(classId) {
  const adminClassesDelete = functions.httpsCallable('adminClassesDelete');
  return await adminClassesDelete({ classId });
}

export default {
  add,
  update,
  delete: deleteClass
};
